import { FeatureFlagType } from '~/enums/FeatureFlagType';
import { User } from '~/types/User';

export const testHasFlag =
  (flag: FeatureFlagType) =>
  (user: User): boolean => {
    return Boolean(user.feature_flags?.includes(flag));
  };
